import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DataManagementAppService } from 'src/app/services/data-management-app.service';

@Component({
  selector: 'app-available-data-sources',
  template: `
    <div class="ds-section">
      <div class="sec-head">
        <h2>Your data sources</h2>
        <span class="meta">{{ availableDataSources.length }} connected</span>
      </div>

      <div class="ds-grid">
        <div
          class="ds-card"
          (click)="setDataSourceName(dataSet['data_name'])"
          [routerLink]="
            '/home/data_management/data_configuration/data_pull/' +
            dataSet['data_name']
          "
          *ngFor="let dataSet of availableDataSources"
        >
          <div class="ds-ico">
            <svg
              viewBox="0 0 24 24"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              stroke-width="1.7"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <ellipse cx="12" cy="5" rx="8" ry="3" />
              <path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
              <path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
            </svg>
          </div>
          <div class="ds-nm" matTooltip="{{ dataSet['data_name'] }}">
            {{ dataSet['data_name'] | namingsize : 28 }}
          </div>
          <div class="ds-when">
            Updated {{ dataSet['updated_dtm'] | date : 'mediumDate' }}
          </div>
        </div>

        <div
          class="ds-card ds-add"
          routerLink="/home/data_management/data_sources"
        >
          <div class="circle">
            <svg
              viewBox="0 0 24 24"
              width="22"
              height="22"
              fill="none"
              stroke="currentColor"
              stroke-width="2.2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 5v14M5 12h14" />
            </svg>
          </div>
          <div class="t">Add data source</div>
          <div class="s">Connect or upload</div>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./available-data-sources.component.scss'],
})
export class AvailableDataSourcesComponent implements OnInit {
  availableDataSources: any = [];
  constructor(
    private dataManagementService: DataManagementAppService,
    private datePipe: DatePipe
  ) {}
  ngOnInit(): void {
    this.dataManagementService.getConfiguredDataSource().subscribe({
      next: (response: any) => {
        response.sort((a: any, b: any) => {
          const dateA = new Date(a.updated_dtm).getTime();
          const dateB = new Date(b.updated_dtm).getTime();

          // Sorting in descending order
          return dateB - dateA;
        });
        this.availableDataSources = response.slice(0, 3);
      },
    });
  }

  setDataSourceName(name: string) {
    this.dataManagementService.setDataSourceName(name);
  }
}
